<!-- src/components/Reportes/MermasVenaScrap/components/MVSSelectorPeriodo.vue -->
<template>
  <div class="mvs-selector">
    <div class="mvs-selector__bloque">
      <label class="mvs-selector__label">Periodo (gráfica y totales)</label>
      <div class="mvs-selector__rango">
        <input type="date" v-model="principalLocal.inicio" @change="emitirPrincipal" />
        <span class="mvs-selector__sep">a</span>
        <input type="date" v-model="principalLocal.fin" @change="emitirPrincipal" />
      </div>
    </div>

    <div class="mvs-selector__bloque mvs-selector__bloque--maquinas" ref="dropdownRef">
      <label class="mvs-selector__label">Máquinas</label>
      <div class="mvs-multiselect">
        <button type="button" class="mvs-multiselect__btn" @click="abierto = !abierto">
          <span>{{ textoBoton }}</span>
          <span
            class="mvs-multiselect__caret"
            :class="{ 'mvs-multiselect__caret--abierto': abierto }"
            >▾</span
          >
        </button>

        <div v-if="abierto" class="mvs-multiselect__panel">
          <label class="mvs-multiselect__opcion mvs-multiselect__opcion--todas">
            <input
              type="checkbox"
              :checked="seleccionadasLocal.length === 0"
              @change="seleccionarTodas"
            />
            Todas las máquinas
          </label>

          <div v-if="cargandoMaquinas" class="mvs-multiselect__vacio">Cargando…</div>
          <div class="mvs-multiselect__lista" v-else>
            <label
              v-for="maquina in catalogoMaquinas"
              :key="maquina.id"
              class="mvs-multiselect__opcion"
            >
              <input
                type="checkbox"
                :value="maquina.id"
                v-model="seleccionadasLocal"
                @change="emitirMaquinas"
              />
              {{ maquina.nombre }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed, watch, onMounted, onBeforeUnmount } from "vue";

const props = defineProps({
  periodoPrincipal: { type: Object, required: true },
  maquinasSeleccionadas: { type: Array, default: () => [] }, // ids; vacío = todas
  catalogoMaquinas: { type: Array, default: () => [] },
  cargandoMaquinas: { type: Boolean, default: false },
});

const emit = defineEmits(["update:periodo-principal", "update:maquinas-seleccionadas"]);

const principalLocal = reactive({ ...props.periodoPrincipal });
const seleccionadasLocal = ref([...props.maquinasSeleccionadas]);
const abierto = ref(false);
const dropdownRef = ref(null);

watch(
  () => props.periodoPrincipal,
  (nuevo) => Object.assign(principalLocal, nuevo)
);

watch(
  () => props.maquinasSeleccionadas,
  (nuevo) => {
    seleccionadasLocal.value = [...nuevo];
  }
);

const textoBoton = computed(() => {
  if (!seleccionadasLocal.value.length) return "Todas las máquinas";
  if (seleccionadasLocal.value.length === 1) {
    const m = props.catalogoMaquinas.find((m) => m.id === seleccionadasLocal.value[0]);
    return m?.nombre || "1 máquina";
  }
  return `${seleccionadasLocal.value.length} máquinas seleccionadas`;
});

function emitirPrincipal() {
  if (!principalLocal.inicio || !principalLocal.fin) return;
  emit("update:periodo-principal", { ...principalLocal });
}

function emitirMaquinas() {
  emit("update:maquinas-seleccionadas", [...seleccionadasLocal.value]);
}

function seleccionarTodas() {
  seleccionadasLocal.value = [];
  emitirMaquinas();
}

function manejarClickFuera(e) {
  if (dropdownRef.value && !dropdownRef.value.contains(e.target)) {
    abierto.value = false;
  }
}

onMounted(() => document.addEventListener("click", manejarClickFuera));
onBeforeUnmount(() => document.removeEventListener("click", manejarClickFuera));
</script>
